export default {"src":"/_next/static/media/fb-orange.4ef58257.svg","height":32,"width":32};